<section>
  <div class="form-register">
    <form [formGroup]="formNoteConcept">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-6 col-12">
          <div class="row align-items-end">
            <div class="col-lg-2 col-md-3 col-sm-6 col-12">
              <app-custom-select formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
                [list]="listConceptInvoicing" [required]="true" (onChangeSelect)="getConceptInvoicing($event, true)">
              </app-custom-select>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-6 col-12">
              <app-custom-select formControlName="storeId" [labelText]="'Bodega'" [list]="listStore" [required]="true"
                (onChangeSelect)="getStore($event, true)">
              </app-custom-select>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6">
              <app-custom-input-decimal formControlName="invoicedValue" [labelText]="'Vr.Facturado'" [required]="true">
              </app-custom-input-decimal>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6">
              <app-custom-input-decimal formControlName="invoiceResidue" [labelText]="'Vr.Saldo'"
                [required]="true"></app-custom-input-decimal>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6">
              <app-custom-input-decimal formControlName="value" [labelText]="'Vr.Total'"
                [required]="true"></app-custom-input-decimal>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6">
              <div class="d-flex justify-content-left container-buttons gap-1">
                <app-custom-button [title]="'Guardar Detalle'" [label]="'Guardar'" [severity]="'primary'"
                  (onClick)="send()"></app-custom-button>
                <app-custom-button [label]="'Cancelar'" [severity]="'danger'"
                  (onClick)="clearForm(false)"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>